import {Component} from "@angular/core";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";

@Component({
    templateUrl: './shop-session-dashboard.component.html',
    styleUrls: ['./shop-session-dashboard.component.scss', './shop-session-dashboard-tab.scss'],
    standalone: false
})
export class ShopSessionDashboardComponent extends BaseComponent {

    loading: boolean = false;

    activeTab = 0;

    constructor(
        loggerService: LoggerService,
        userService: UserService,
    ) {
        super(userService, loggerService);
    }

    setActiveTab(tabIndex: number) {
        this.activeTab = tabIndex;
    }
}
